import React from "react";
import "./contact.css";
import { FaPhone, FaEnvelope } from "react-icons/fa";

const Contact = () => {
  return (
    <div className="contact-section">
      {/* Top Image */}
      <img
        src="/images/contact.png" // put image inside /public or /src/assets
        alt="Contact"
        className="contact-img"
      />

      {/* Buttons */}
      <div className="contact-buttons">
        <button className="btn-black">पत्ता </button>
        <button className="btn-black">संपर्क</button>
      </div>

      {/* Contact Info Grid */}
      <div className="contact-info">
        {/* Left Side (Address) */}
        <div className="contact-left">
          <p>सांगली रस्ते पोस्ट ऑफिस जवळ,</p>
          <p>कुपवाड, 416402</p>
          <p>तहसील : जत, तालुका : जत, जिल्हा : सांगली, महाराष्ट्र</p>
        </div>

        {/* Right Side (Phone + Email) */}
        <div className="contact-right">
          <p>
            <FaPhone className="icon" /> +91 9373330114
          </p>
          <p>
            <FaEnvelope className="icon"/> varadvinayaksa9940@gmail.com
          </p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
